
const state = {
  isShow: false,
  dataSetting: {},
  isEditAction: false,
  defaultOption: false,
  editSettingCompanyComplete: false,
  listCompanies: []
}
const getters = {
  isShow (state) {
    return state.isShow
  },
  dataSetting (state) {
    return state.dataSetting
  },
  dataDefaultOption(state) {
    return state.defaultOption
  },
  editSettingCompleteComplete (state) {
    return state.editSettingCompanyComplete
  },
  getListCompanies (state) {
    return state.listCompanies
  },
  isEditAction (state) {
    return state.isEditAction
  }
}

const mutations = {
  OPEN_POPUP (state, dataPopup) {
    state.isShow = true
    state.dataSetting = dataPopup
  },
  CLOSE_POPUP (state) {
    state.isShow = false
    state.dataSetting = {}
    state.isEditAction = false
  },
  EDIT_COMPLETE(state) {
    state.editSettingCompanyComplete = !state.editSettingCompanyComplete
  },
  DEFAULT_OPTION(state, data) {
    state.defaultOption = data
  },
  SET_LIST_COMPANIES(state, data) {
    state.listCompanies = data
  },
  SET_IS_EDIT_ACTION(state, data) {
    state.isEditAction = data
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
